import type { BirdFrameName } from "./types.ts";

export const HIGHLIGHT_START = "\x02";
export const HIGHLIGHT_END = "\x03";

export const CHASSIS_TOP: string = [
  "   .----------------------------------------------.",
  "   |  .----------------------------------------.  |",
  "   |  |{{SCREEN_1}}|  |",
  "   |  |{{SCREEN_2}}|  |",
  "   |  |{{SCREEN_3}}|  |",
  "   |  |{{SCREEN_4}}|  |",
  "   |  |{{SCREEN_5}}|  |",
  "   |  |{{SCREEN_6}}|  |",
  "   |  |{{SCREEN_7}}|  |",
  "   |  |{{SCREEN_8}}|  |",
  "   |  |{{SCREEN_9}}|  |",
  "   |  |{{SCREEN_10}}|  |",
  "   |  |{{SCREEN_11}}|  |",
  "   |  |{{SCREEN_12}}|  |",
  "   |  |{{SCREEN_13}}|  |",
  "   |  |{{SCREEN_14}}|  |",
  "   |  '----------------------------------------'  |",
  "   |    APPLE  ][e                                |",
  "   '----------------------------------------------'",
].join("\n");

export const SCREEN_COLS = 40;
export const SCREEN_ROWS = 14;

export const KEYBOARD_NORMAL: string = [
  "          [Q][W][E][R][T][Y][U][I][O][P]",
  "          [A][S][D][F][G][H][J][K][L][;]",
  "          [Z][X][C][V][B][N][M][,][.][/]",
].join("\n");

export const KEYBOARD_Y_HIT: string = [
  `          [Q][W][E][R][T]${HIGHLIGHT_START}[Y]${HIGHLIGHT_END}[U][I][O][P]`,
  "          [A][S][D][F][G][H][J][K][L][;]",
  "          [Z][X][C][V][B][N][M][,][.][/]",
].join("\n");

// Bird sprites, 10 rows each, ~13 cols wide.
// They sit inside the CRT screen, right-aligned by the renderer.
export const BIRD_FRAMES: Record<BirdFrameName, string[]> = {
  idle: [
    "    .-.    ",
    "   ( o )   ",
    "    \\=/    ",
    "     |     ",
    "    _|_    ",
    "   ( ~ )   ",
    "    \\_/    ",
    "    | |    ",
    "   _| |_   ",
    "  /_____\\  ",
  ],
  peck_mid: [
    "             ",
    " .-.         ",
    "(o )___      ",
    "\\=/(   )     ",
    " \\  \\~/      ",
    "  \\  /       ",
    "   \\/        ",
    "  _||_       ",
    " /____\\      ",
    "             ",
  ],
  peck_contact: [
    "             ",
    "             ",
    ".-.          ",
    "<o )____     ",
    " \\=/    \\    ",
    "    \\~~/     ",
    "     \\/      ",
    "    _||_     ",
    "   /____\\    ",
    "             ",
  ],
  slump: [
    "           ",
    "           ",
    "           ",
    "           ",
    "           ",
    "       .-. ",
    "      ( x )",
    "       \\_/ ",
    " _____  |  ",
    "/_____\\_|__",
  ],
};
